import React from 'react';
import { toast } from 'react-hot-toast';

interface ConfirmToastOptions {
  confirmText?: string;
  cancelText?: string;
  durationMs?: number;
}

export const confirmToast = (
  message: string,
  { confirmText = 'Confirm', cancelText = 'Cancel', durationMs = 10000 }: ConfirmToastOptions = {}
): Promise<boolean> => {
  return new Promise((resolve) => {
    let settled = false;

    const resolveOnce = (value: boolean, toastId: string) => {
      if (settled) return;
      settled = true;
      toast.dismiss(toastId);
      resolve(value);
    };

    const toastId = toast.custom((t) => (
      <div className="min-w-[400px] max-w-md rounded-lg bg-white p-6 shadow-2xl border-2 border-gray-300 backdrop-blur-sm">
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
              <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
          </div>
          <div className="flex-1">
            <h3 className="text-base font-semibold text-gray-900 mb-1">Confirm Action</h3>
            <p className="text-sm text-gray-600">{message}</p>
          </div>
        </div>
        <div className="mt-5 flex justify-end space-x-3">
          <button
            onClick={() => resolveOnce(false, toastId)}
            className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          >
            {cancelText}
          </button>
          <button
            onClick={() => resolveOnce(true, toastId)}
            className="rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          >
            {confirmText}
          </button>
        </div>
      </div>
    ), {
      position: 'top-center',
      duration: durationMs,
    });

    if (durationMs > 0) {
      setTimeout(() => resolveOnce(false, toastId), durationMs);
    }
  });
};
